<template>
  <section>
    <RequisiteAdvanceRules
      :value="value.rules"
      :level="level"
    />
    <template v-if="value.freeFormText">
      <label class="pt-2 block text-gray-500 text-sm">Additional Comments</label>
      <div
        class="mb-2 reset-liststyle"
        v-html="value.freeFormText"
      />
    </template>
  </section>
</template>

<script>
import RequisiteAdvanceRules from './RequisiteAdvanceRules'

export default {
  components: {
    RequisiteAdvanceRules,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    level: {
      type: Number,
      default: 0,
    },
  },
}
</script>
